import React from "react";

interface PractitionerInsightProps {
  title: string;
  role: string;
  org: string;
  description?: string;    // optional extra description
  children?: React.ReactNode;
}

export const PractitionerInsight: React.FC<PractitionerInsightProps> = ({
  title,
  role,
  org,
  description,
  children,
}) => {
  return (
    <div className="rounded-xl bg-blue-50 dark:bg-blue-900/20 p-4 border border-blue-200 dark:border-blue-700 mt-6">
      <h3 className="text-base font-semibold text-blue-800 dark:text-blue-300">
        {title}
      </h3>
      <p className="text-xs text-blue-700 dark:text-blue-400 mb-2">
        {role}, {org}
      </p>
      {description && (
        <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">
          {description}
        </p>
      )}
      <div className="text-sm text-gray-800 dark:text-gray-100">{children}</div>
    </div>
  );
};

export default PractitionerInsight;
